import { render, staticRenderFns } from "./AdminHospitalPatientList.vue?vue&type=template&id=0c1e096b&scoped=true"
import script from "./AdminHospitalPatientList.vue?vue&type=script&lang=js"
export * from "./AdminHospitalPatientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1e096b",
  null
  
)

export default component.exports